import Axios from "axios";
import {
  SET_BONUS_AGING_REPORT_LIST,
  UNSET_BONUS_AGING_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getBonusAgingReport,
} from "@/store/api";

const state = {
  getBonusAgingReport: [],
};

const getters = {
  getBonusAgingReport(state) {
    return state.getBonusAgingReport;
  },
};

const mutations = {
  [SET_BONUS_AGING_REPORT_LIST](state, data) {
    state.getBonusAgingReport = data;
  },
  [UNSET_BONUS_AGING_REPORT_LIST](state) {
    state.getBonusAgingReport = [];
  },
};

const actions = {
  getBonusAgingReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getBonusAgingReport}`, { params: data })
        .then((response) => {
          commit(SET_BONUS_AGING_REPORT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_BONUS_AGING_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

